export const RESULTS_PER_PAGE = 20;
export const RESULTS_PER_PAGE_JOB = 20;

export const DATE_FORMAT = 'MM/DD/YY';

export const PLAN_EXP_DATE_FORMAT = 'DD MMM YYYY';

export const DATE_TIME_FORMAT = 'MM/DD/YYYY hh:mm a';

// User-selectable date/time display formats.
// Keys are the enums stored on the user profile; values are moment format strings.
export const DATE_FORMAT_MAP = {
  MMDDYYYY: 'MM/DD/YYYY',
  DDMMYYYY: 'DD/MM/YYYY',
  YYYYMMDD: 'YYYY-MM-DD',
  MONTHDDYYYY: 'MMMM D, YYYY',
  DDMONTHYYYY: 'D MMMM YYYY'
};

export const TIME_FORMAT_MAP = {
  '12HR': 'h:mm A',
  '24HR': 'HH:mm'
};

// Options for the User Config dropdowns ({ value: <enum>, label }).
export const DATE_FORMAT_OPTIONS = [
  { value: 'MMDDYYYY', label: 'MM/DD/YYYY' },
  { value: 'DDMMYYYY', label: 'DD/MM/YYYY' },
  { value: 'YYYYMMDD', label: 'YYYY-MM-DD' },
  { value: 'MONTHDDYYYY', label: 'May 19, 2026' },
  { value: 'DDMONTHYYYY', label: '19 May 2026' }
];

export const TIME_FORMAT_OPTIONS = [
  { value: '12HR', label: '12-hour (2:45 PM)' },
  { value: '24HR', label: '24-hour (14:45)' }
];

export const DEFAULT_DATE_FORMAT = 'MMDDYYYY';
export const DEFAULT_TIME_FORMAT = '12HR';

export const SEARCH_DELAY = '400';

export const API_CALL_DELAY = '400';

export const AUTO_SAVE_DELAY = '1000';

export const NAME_REGEX_CHECK =
  "^([A-Za-z]|(([A-Za-z]+)([.,] |[-']| )*)+[A-Za-z]+?)$";

export const ZIPCODE_REGEX_CHECK = '^[a-zA-Z0-9]*$';

export const CLIENT_KEY = process.env.REACT_APP_CLIENT_KEY;

export const CURRENCY_SYMBOL = '$';

export const NAME = process.env.REACT_APP_LOGIN_ID;

export const IDLE_LOGOUT_TIME_MINUTES = 25;
